import React from 'react';
import { Field } from 'redux-form';
import { ReduxFormSelect } from '@common/components/FormElements';

const optionsForPerTimeRange = (options) =>
  options.map((option, index) => ({
    label: `${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(0, 5)}`,
    value: index,
  }));

export const PerTimeRange = ({ id, options }) => (
  <Field
    component={ReduxFormSelect}
    name={`extras.${id}.option`}
    options={optionsForPerTimeRange(options)}
  />
);
